/** @jsxImportSource @emotion/react */
import { styles } from './CollapsedJob.styles';
import { Job } from '../../api/JobsApi';

export default function CollapsedJob({ job }: { job: Job }) {
  const skills = job.skills ?? [];
  return (
    <div css={styles.wrapper}>
      <div css={styles.header}>
        <h3>{job.title}</h3>
        {job.type?.name && <span css={styles.badge}>{job.type.name}</span>}
      </div>

      <p css={styles.location}>{job.location?.name}</p>

      {skills.length > 0 && (
        <div css={styles.skills}>
          {skills.map(s => (
            <span key={s.id}>{s.name}</span>
          ))}
        </div>
      )}
    </div>
  );
}
